export const initialState = {
  isLoading: false,
};
